import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Тепловоз ТЭМ15 017';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Типа ТЭМ15 №017</p>
                    <p>Построен в 1988 году на Брянском машиностроительном заводе</p>
                    <p>Тип - маневровый</p>
                    <p>Конструктивная скорость - 100 км/ч</p>
                    <p>Масса - 120т</p>
                    <p>Мощность - 1200 л.с.</p>
                    <p>Нагрузка на ось -18т</p>
                    <p>Дальнейшее развитие серии ТЭМ2М. Изначально был спроектирована для Кубы. Выпуск прекращён в связи с прекращением выпуска дизелей 6Д49. Эти локомотивы поставлялись только промышленным предприятиям.</p>
                    <p>Годы выпуска 1987-1995 г.г.</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt060.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt061.jpg')} /></div>
            </div>
        </>
    );
}